require('../../admin/jv.Admin.Ajax.Factory');

angular.module('jv.tracking.jobBoards.service', [
    'jv.Admin.Ajax.Factory'
    ])

    .service('jobBoardService', ['jvAjaxRequest',
        function (jvAjaxRequest) {
            var _baseUrl = '/admin/action/tracking';

            this.getAllJobBoards = function(onSuccess, onError){
                var options = {
                    ajaxtype: 'getTrackingJoBoardsList',
                    url: '{0}/jobboard/list'.format(_baseUrl)
                };
                jvAjaxRequest({}, options, onSuccess, onError);
            };

            this.addNewJobBoard = function(jobBoard, onSuccess, onError){
                var options = {
                    ajaxtype: 'addNewJoBoard',
                    url: '{0}/jobboard'.format(_baseUrl),
                    requestType: 'POST',
                    headerType: 'json'
                };
                jvAjaxRequest(jobBoard, options, onSuccess, onError);
            };

            this.updateJobBoard = function(jobBoard, onSuccess, onError){
                var options = {
                    ajaxtype: 'editExistingJoBoard',
                    url: '{0}/jobboard/{1}'.format(_baseUrl, jobBoard.name),
                    requestType: 'PUT',
                    headerType: 'json'
                };
                jvAjaxRequest(jobBoard, options, onSuccess, onError);
            };

            this.deleteJobBoard = function(jobBoardName, onSuccess, onError){
                var options = {
                    ajaxtype: 'editExistingJoBoard',
                    url: '{0}/jobboard/{1}'.format(_baseUrl, jobBoardName),
                    requestType: 'DELETE',
                    headerType: 'json'
                };
                jvAjaxRequest({}, options, onSuccess, onError);
            };
        }
    ]);
